import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import type { FilePopulated, FlashcardSetPopulated, FolderPopulated, NotePopulated, QuizPopulated } from "@vita-learning/types";
import { FlashcardItem, FolderItem, QuizItem, FileItem, NoteItem } from "~/client/components/items";
export type WorkspaceItemProps = {
  type: "folder";
  data: FolderPopulated;
} | {
  type: "note";
  data: NotePopulated;
} | {
  type: "flashcards";
  data: FlashcardSetPopulated;
} | {
  type: "quiz";
  data: QuizPopulated;
} | {
  type: "file";
  data: FilePopulated;
};
export const WorkspaceItem: FC<WorkspaceItemProps> = t0 => {
  const $ = _c(10);
  const {
    type,
    data
  } = t0;
  switch (type) {
    case "folder":
      {
        let t1;
        if ($[0] !== data) {
          t1 = <FolderItem folder={data} />;
          $[0] = data;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "note":
      {
        let t1;
        if ($[2] !== data) {
          t1 = <NoteItem note={data} />;
          $[2] = data;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "flashcards":
      {
        let t1;
        if ($[4] !== data) {
          t1 = <FlashcardItem flashcardSet={data} />;
          $[4] = data;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "quiz":
      {
        let t1;
        if ($[6] !== data) {
          t1 = <QuizItem quiz={data} />;
          $[6] = data;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case "file":
      {
        let t1;
        if ($[8] !== data) {
          t1 = <FileItem file={data} />;
          $[8] = data;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    default:
      {
        throw new Error(`Unsupported workspace item type: ${type}`);
      }
  }
};